import { useAuth0 } from '@auth0/auth0-react';
import { CollapsibleSidebarAndMainContent } from '@strata/react-collapsible-sidebar-and-main-content';
import { LeftSideNav } from '@strata/react-left-side-navbar';
import { type ComponentProps, type ReactElement } from 'react';

import { AppRoutes } from 'services/routes';

interface SideNavProps {
    children: ReactElement;
}

export const SideNav = ({ children }: SideNavProps) => {
    const { user, logout } = useAuth0();

    const navTabContent: ComponentProps<typeof LeftSideNav>['navTabContent'] = [
        {
            navSection: 'Members',
            navItems: [
                {
                    label: 'Create Test Member',
                    to: AppRoutes.createMember,
                },
                {
                    label: 'View Test Member',
                    to: AppRoutes.viewMember,
                },
            ],
        },
        {
            navSection: 'Referrals',
            navItems: [
                {
                    label: 'Test Referral',
                    to: AppRoutes.referral,
                },
                {
                    label: 'Batch Referrals',
                    to: AppRoutes.batch,
                },
            ],
        },
        {
            navSection: 'Claim',
            navItems: [
                {
                    label: 'Test Pharmacy Claim',
                    to: AppRoutes.claim,
                },
            ],
        },
        {
            navSection: 'Developer',
            navItems: [
                {
                    label: 'Service Bus',
                    to: AppRoutes.serviceBus,
                },
            ],
        },
        {
            navSection: 'Admin',
            navItems: [
                {
                    label: 'Edit Auction End Time',
                    to: AppRoutes.editAuctionEnd,
                },
                {
                    label: 'Clear Worklist Tasks',
                    to: AppRoutes.clearTasks,
                },
                {
                    label: 'Create Worklist Task',
                    to: AppRoutes.worklist,
                },
                {
                    label: 'Create Rebilling Task',
                    to: AppRoutes.rebilling,
                },
            ],
        },
        {
            navSection: 'Incident Management',
            navItems: [
                {
                    label: 'INCIDENTS',
                    to: AppRoutes.viewIncidents,
                },
            ],
        },
    ];

    const onLogOutClick = () => {
        void (async () => {
            sessionStorage.clear();
            await logout({
                logoutParams: { returnTo: `${window.location.origin}${AppRoutes.loggedOut}` },
            });
        })();
    };

    return (
        <div className="sds_main-content">
            <CollapsibleSidebarAndMainContent
                sidebarContent={
                    <LeftSideNav
                        navTabContent={navTabContent}
                        loggedInUser={user?.name}
                        onLogOutClick={onLogOutClick}
                        fmhEnvironmentForTag={process.env.REACT_APP_ENV}
                    />
                }
                mainContent={children}
            />
        </div>
    );
};
